/*
@file-overview 

- This service contains a collection of global window methods availible on AEM pages and other SPA applications

- NOTE : None of these functions are currently being used in this abs-ngx-library 

*/
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import {UserInfoService} from './user-info.service'
import { UtilService } from './util.service'

@Injectable({
  providedIn: 'root'
})
export class AemService {

  constructor(private _configService: ConfigService, 
    private _userInfoService:UserInfoService,
    private _utilService:UtilService
    ) {}

  // AB
  public getXPIgalleryPath() {
    return window['AB'].xAPIgalleryPath;
  }

  public getInstantAllocation() {
    return window['AB'].instantAllocation;
  }

  public getCompanionOffersxAPIHttpOptions() {
    return window['AB'].companionOffersxAPIHttpOptions; //available in fullcart window
  }

  public getGalleryRegisterPath() {
    return window['AB'].galleryRegisterPath;
  }

  public getJ4uHttpOptions() {
    return window['AB'].j4uHttpOptions;
  }

  public getJ4uHttpOptions11() {
    return window['AB'].j4uHttpOptions11;
  }

  public getPreUcaHttpOptions() {
    return window['AB']['preUcaHttpOptions'];
  }

  public getLoyaltyPartnersPath() {
    return window['AB']['loyaltyPartnersPath'];
  }

  public removeHistoryAction() {
    return window['AB']['removeHistoryAction'];
  }

  public getSearchRank() {
    return window['AB']['searchRank'];
  }

  public setSearchRank(searchRank) {
    window['AB']['searchRank'] = searchRank;
  }

  public getDealsFilter() {
    return window['AB']['dealsFilter']; //available in full cart window
  }

  public getCartApimKey() {
    return window['AB']['cartapimkey'];
  }

  public getCartApimTrace():string {
    return window['AB']['cartapimtrace'];
  }

  public getCartBaseUrl() {
    return window['AB']['cartbaseurl'];
  }

  public getCartUrl() {
    return window['AB']['carturl'];
  }

  public getCartByCustUrl() {
    return window['AB']['getcartbycusturl'];
  }

  public getAddToCartPath() {
    return window['AB']['addToCartPath']; //available in full cart window
  }

  public getDMTProductCard() {
    return this._configService.getProductConfig().productImageUrl;
   // return window['AB']['dMTProductCard'];
  }

  public getDMTMiniCart() {
    return window['AB']['dMTMiniCart'];
  }

  public getRemoveProductHistoryPath() {
    return window['AB']['removeProductHistoryPath']; //available in full cart window
  }

  public getAttendDeliveryTxt() {
    return window['AB']['attendDeliveryTxt']; //available in full cart window
  }

  public getCouponClipPath() {
    return window['AB']['couponClipPath']; //available in full cart window
  }

  public getCouponUnclipPath() {
    return window['AB']['couponUnclipPath'];
  }

  public getMiniCartPath() {
    return window['AB']['miniCartPath'];
  }

  public getProductGridPage() {
    return window['AB']['productGridPage'];
  }

  public getItemNotAvailableTxt() {
    return window['AB']['itemNotAvailableTxt']; //available in full cart window
  }

  public getAvailableSorts() {
    return window['AB']['availableSorts'];
  }

  public getHeaderType() {
    return window['AB']['headerType'];
  }

  public getDefaultSort() {
    return window['AB']['defaultSort'];
  }

  public getOfferId() {
    return window['AB']['offerId'];
  }

  public getGridDataURL() {
    return window['AB']['gridDataURL']; //available in full cart window
  }

  public getGridDataURLNoParam() {
    return window['AB']['gridDataURLNoParam'];
  }

  public getAisleHTMLPath() {
    return window['AB']['aisleHTMLPath'];
  }

  public getAisleHTMLTitlePath() {
    return window['AB']['aisleHTMLTitlePath'];
  }

  public getLastOrderErumsHttpOptions() {
    return window['AB']['lastOrderErumsHttpOptions'];
  }

  public getAemAislePath() {
    return window['AB']['aemAislePath'];
  }

  public getErrorText() {
    return window['AB']['errorText'];
  }

  public getCatalogXapiProductsBpnEndpoint() {
    return window['AB']['catalogXapiProductsBpnEndpoint'];
  }

  public getCatalogXapiProductsUpcEndpoint() {
    return window['AB']['catalogXapiProductsUpcEndpoint'];
  }

  // AB LAZYLOAD
  public initLazyLoad() {
    if (window['AB']['LAZYLOAD']) {
      window['AB']['LAZYLOAD'].init(); //available in full cart window
    }
  }

  // AB CART
  public mergeCart() {
    window['AB'].CART._mergeCart();
  }

  // AB USERINFO
  public getUserInfo() {
    return window['AB'] ? window['AB']['userInfo'] : undefined; //Empty object in full cart window
  }

  public getCustomerId() {
    return window['AB']['userInfo'].customerId;
  }

  public getBranchId() {
    return window['AB']['userInfo']['branchId'];
  }

  public getPreferenceMode() {
    return window['AB']['userInfo']['preferenceMode'];
  }

  public getBoxTopAuth() {
    return window['AB'].userInfo.boxTopAuth;
  }

  public setBoxTopAuth(auth) {
    window['AB'].userInfo.boxTopAuth = auth;
  }

  public getSWY_SHOP_TOKEN() {
    return window['AB']['userInfo']['SWY_SHOP_TOKEN'];
  }

  public clubCard() {
    return window['AB']['userInfo']['clubCard'];
  }

  public getBanner() {
    return window['AB']['userInfo']['banner'];
  }

  public getBoxTopCalled() {
    return window['AB'].userInfo.boxTopCalled;
  }

  public setBoxTopCalled(boxTopCalled) {
    window['AB'].userInfo.boxTopCalled = boxTopCalled;
  }

  // AB USERINFO J4U
  public getStoreId() {
    return window['AB'].userInfo.j4u.storeId
  }

  public getHouseId() {
    return window['AB']['userInfo'].houseId;
  }

  public unattendedDeliveryIsEnabled() {
    return window['AB']['userInfo']['unattendedDeliveryIsEnabled'];
  }

  // AB COMMON
  public getURLParameterByName(name: string, doDecode? : boolean) {
    return window['AB']['COMMON'].getURLParameterByName(name, doDecode); //COMMON available in full cart window
  }

  public authorize() {
    return window['AB']['COMMON'].authorize();
  }

  public isProductCardABtestEnabled() {
    return window['AB']['COMMON'] && window['AB']['COMMON'].isProductCardABtestEnbaled ? window['AB']['COMMON'].isProductCardABtestEnbaled() : false;
  }

  public sessionNotExpired() {
    return true; // FIX
  //  return window['AB']['COMMON'].sessionNotExpired();
  }

  public checkCartId(cartName) {
    return window['AB']['COMMON'].checkCartId(cartName);
  }

  public getCartId(cartName) {
    return window['AB']['COMMON'].getCartId(cartName);
  }

  public setCartId(cartName, cartId) {
    window['AB']['COMMON'].setCartId(cartName, cartId);
  }

  public invalidateCartId() {
    window['AB']['COMMON'].invalidateCartId();
  }
 
  public isLSCompatible() {
    return window['AB'].COMMON.isLSCompatible();
  }

  public getStoreStatus() {
    if (window[ 'AB' ]['COMMON'] && window[ 'AB' ]['COMMON'].getStoreStatus)
      window[ 'AB' ]['COMMON'].getStoreStatus();
  }

  public ucaAPIPathWithCustomerId(path) {
    return window["AB"].COMMON.ucaAPIPathWithCustomerId(path);
  }

  public showCreateAccountModalJ4U(clickSource, modalLink?: any) {
    window['AB']['COMMON'].showCreateAccontModalJ4U(clickSource, modalLink);
  }

  public getCookie(cookieName) {
    return window['AB'].COMMON.getCookie(cookieName);
  }

  /**
   * Method to get slotInfo cookie based on site type
   * returns slotInfo cookie
   */
  public getSlotIdCookie() {
    if (this._userInfoService.getSiteType() === 'B'){
      return this._utilService.getCookie('B_SlotInfo');
    } else {
        return this._utilService.getCookie('SlotInfo');
    }
  }

  public getOrderNumberCookie()
  {
    if (this._userInfoService.getSiteType() === 'B')
    {
        return this._utilService.getCookie('B_OrderNumber');
    }
    return this._utilService.getCookie('OrderNumber');
  }

  public getOrderStoredIdCookie()
  {
    if (this._userInfoService.getSiteType() === 'B')
    {
        return this._utilService.getCookie('B_OrderStoreId');
    }
    return this._utilService.getCookie('OrderStoreId');
  }

  // get the order preference (channel) from the cookie
    public getOrderPreferenceCookie() {
      if (this._userInfoService.getSiteType() === 'B')
        {
            return this._utilService.getCookie('B_OrderPreference');
        }
        return this._utilService.getCookie('OrderPreference');
  }

  public setCookie(cookieName, cookieValue, expireDays? : any) {
    window['AB']['COMMON'].setCookie(cookieName, cookieValue, expireDays);
  }

  public getUserChannel() {
    return window['AB']['COMMON'] && window['AB']['COMMON'].getUserChannel ? window['AB']['COMMON'].getUserChannel() : '';
  }

  public checkUnAttendedDelivery() {
    return window[ 'AB' ].COMMON.checkUnAttendedDelivery();
  }

  public getBreakpoint() {
    return window['AB']['COMMON'].getBreakpoint();
  }

  public getAisleLevel3Id() {
    return window['AB']['aisleLevel3Id'];
  }

  public getAvailabilityCheck() : boolean {
    const availableItemsOnly = this.getURLParameterByName('availability', true);
    return availableItemsOnly === 'true' ? true : false;
  }

  // AB MINICART
  //Empty object on full cart page
  public loadCartPrice() {
    window['AB']['MINICART'].loadCartPrice();
  }

  public getBaseURLeRUMS() {
    return window['AB']['MINICART'].getBaseURLeRUMS();
  }

  // AB ALERT
  //Empty object on full cart page
  public checkReserveTime() {
    window['AB']['ALERT'].checkReserveTime();
  }

  // SWY ENFORCEMENTUTILS
  //Available on window in full cart page
  public updateReInitSite(targetSite) {
    window['SWY'].ENFORCEMENTUTILS.updateReInitSite(targetSite);
  }

  public checkAuthorizedCookie() {
    return window['SWY'].ENFORCEMENT.checkAuthorizedCookie()
  }

  public isTokenActive() {
    return window['SWY'].ENFORCEMENT.isTokenActive();
  }


  // SWY CONFIGSERVICE
  public featureToggleConfig() {
    return window['SWY'].CONFIGSERVICE.featureToggleConfig;
  }

  public getProp65Details() {
    return window['SWY']['CONFIGSERVICE'].getProp65Details();
  }

  public getDisableInStoreChannelCheck() {
    return window['SWY']['CONFIGSERVICE']
    && window['SWY']['CONFIGSERVICE'].featureToggleConfig
    && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableInStoreChannelCheck')
        ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableInStoreChannelCheck
        : true;
  }
  public getDnfEligilityDisabledCheck() {
    return window['SWY']['CONFIGSERVICE']
    && window['SWY']['CONFIGSERVICE'].featureToggleConfig
    && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('dnfEligibilityDisabled')
        ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.dnfEligibilityDisabled
        : true;
  }

  public getDisableEcomGalleryApi() {
    return window['SWY']['CONFIGSERVICE']
    && window['SWY']['CONFIGSERVICE'].featureToggleConfig
    && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableEcomGalleryApi')
        ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableEcomGalleryApi
        : true;
  }

  // SWY CONFIGSERVICE SEARCHCONFIG
  public getApimSubscriptionKey() {
    return window['SWY'] && window['SWY'].CONFIGSERVICE && window['SWY'].CONFIGSERVICE.searchConfig ? window['SWY'].CONFIGSERVICE.searchConfig['apimSubscriptionKey'] : undefined;
//    return window['SWY'].CONFIGSERVICE.searchConfig.apimSubscriptionKey;
  }

  public getApimSearchPath() {
    return window['SWY'].CONFIGSERVICE.searchConfig['apimSearchPath'];
  }

  public getApimSearchSponsoredCarouselEndpoint() {
    return window['SWY'].CONFIGSERVICE.searchConfig['apimSearchSponsoredCarouselEndpoint'];
  }

  // SWY CONFIGSERVICE CATALOGCONFIG
  public getApimCatalogPath() {
    return window['SWY'].CONFIGSERVICE.catalogConfig['apim.api.catalog.path'];
  }

  public getApimCatalogDepartmentsEndpoint() {
    return window['SWY'].CONFIGSERVICE.catalogConfig['apim.api.catalog.departments.endpoint'];
  }

  // SWY CONFIGSERVICE ERUMSCONFIG
  public getEditOrderOldVersion() {
    return window['SWY']['CONFIGSERVICE'].erumsConfig['editorder.oldversion'];
  }

  // SWY CONFIGSERVICE NIMBUSCONFIG
  public getCouponImageBaseUrl() {
    return window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl;
  }

  public getCouponTypes() {
    return window[ 'SWY' ].CONFIGSERVICE.nimbusConfig.couponTypes;
  }

  // SWY CONFIGSERVICE WCAXXAPICONFIG
  public getXApiKey() {
    return window['SWY'].CONFIGSERVICE.wcaxXapiConfig["wcax.xapi.apim.key"];
  }

  public getUidValue(){
    return document.cookie.match('(^|;)\\s*_br_uid_2\\s*=\\s*([^;]+)') || '';
  }
  public isAllowWiremockService(){
    return window['AB'].allowWiremockService;
  }

  public getWcaxXapiApimKey(){
    return window['AB']['wcaxXapiApimKey'];
  }

   // --------------------------------------------------------------------------
  /**
   *  Returns the base location of the feature flags
   */
  // --------------------------------------------------------------------------
  public getFeatureFlagBase() {
    return window['SWY']?.CONFIGSERVICE?.featureToggleConfig;
  }

   /**
   *  DESCRIPTION:  Generic function to retrive all base flags
   *  flagKey - String value of the feature name
   */
  // --------------------------------------------------------------------------
  public getFeatureFlagByNameDisable(flagKey): boolean {
    const baseFlags = { ...this.getFeatureFlagBase() };
    return (baseFlags[flagKey] && baseFlags[flagKey]) !== true ? false : true;
  }
 
  /**
   * Set Domain Cookie
   * 
   * @param cookieName 
   * @param cookieValue 
   * @param expireDays 
   */

  public setDomainCookie(cookieName, cookieValue, expireDays? : any) {
    window['SWY'].CONFIGSERVICE.setDomainCookie(cookieName, cookieValue, window['SWY'].CONFIGSERVICE.resolvedBanner + '.com', expireDays);
  }

  public getArFlag(){
    return window['AB']['arFlag'];
  }

  public isArFlagLoaded(){
    return window['AB']['arFlagLoaded'];
  }

  public isThemeBuilderEnabled(){
    return window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].isThemeBuilderEnabled;
  }

  public getSnsOffer(){
    return window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].bannerConventionsJson
    && window['SWY']['CONFIGSERVICE'].bannerConventionsJson.snsOffer ?
      window['SWY']['CONFIGSERVICE'].bannerConventionsJson.snsOffer : '5%';
  }

  public getBundlesEstimatedTotalEndpoint(){
    return window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['bundlesEstimatedTotal.endpoint'];
  }

  public getBundlesEstimatedTotalSubscriptionKey(){
    return window['SWY']['CONFIGSERVICE'].wcaxXapiConfig['bundlesEstimatedTotal.subkey'];
  }


  public isLSEnabled(){
    return window['AB'].isLSEnabled
  }

  /**
   * check if Wineshop is enabled for store
   */
  public _isWineShopEnabledForStore() {
    const storeFlagsData = window['AB'].storeFlagsData;
    const isWineD2CEnabled = storeFlagsData && storeFlagsData['flags']
    && storeFlagsData['flags']['ecomStore']
    && storeFlagsData['flags']['ecomStore']['storeFeatures']
    && storeFlagsData['flags']['ecomStore']['storeFeatures']['isWineD2CEnabled'] === true ?
        true : false;
    return isWineD2CEnabled;
  }
}
